import * as React from 'react';
import { ISpinButtonProps, SpinButton } from 'office-ui-fabric-react';

type SpinButtonInputProps = ISpinButtonProps & {
    suffix: string;
    numberValue: number;
    onEditComplete: (value: number) => void;
}

export const SpinButtonInput = (props: SpinButtonInputProps) => {
    const { suffix, step = 1, min, max, numberValue } = props;

    const addSufix = (value: number) => value + suffix;
    const hasSuffix = (value: string) => value.substring(value.length - suffix.length) === suffix;
    const removeSuffix = (value: string): number => !hasSuffix(value) ? Number(value) : Number(value.substring(0, value.length - suffix.length));

    const onSpinButtonIncrement = (value: string) => {
        let number = removeSuffix(value);
        if (max === undefined || number + step <= max) {
            number += step
        }

        props.onEditComplete(number);
        return addSufix(number);
    };

    const onSpinButtonDecrement = (value: string) => {
        let number = removeSuffix(value);
        if (min === undefined || number - step >= min) {
            number -= step
        }

        props.onEditComplete(number);
        return addSufix(number);
    };

    const onSpinButtonValidate = (value: string) => {
        let number = removeSuffix(value);
        if (isNaN(number) || max !== undefined && number > max || min !== undefined && number < min || value.trim().length === 0) {
            number = 0;
        }

        props.onEditComplete(number);
        return addSufix(number);
    };

    return <SpinButton
        {...props}
        value={addSufix(numberValue)}
        onValidate={onSpinButtonValidate}
        onIncrement={onSpinButtonIncrement}
        onDecrement={onSpinButtonDecrement}
    />;
};
